// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.healthProblems[data-v-104b8aea]
	{
		border: 3px solid #000000;
		padding: 5px 3.3vw;
}
.healthProblems.hasHealthProblems[data-v-104b8aea]
		{
			border-color: #CC0000;
			color: #990000;
			font-weight: bold;
}
.alertMessage[data-v-104b8aea]
	{
		white-space: pre-line;
}
@media (min-width: 600px)
	{
.healthProblems[data-v-104b8aea]
		{
			border: 3px solid #000000;
			padding: 5px 20px;
}
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/controls/JobProblemDetails.vue"],"names":[],"mappings":";AAsCC;;EAEC,yBAAyB;EACzB,kBAAkB;AACnB;AAEC;;GAEC,qBAAqB;GACrB,cAAc;GACd,iBAAiB;AAClB;AAED;;EAEC,qBAAqB;AACtB;AAEA;;AAEC;;GAEC,yBAAyB;GACzB,iBAAiB;AAClB;AACD","sourcesContent":["<template>\r\n\t<div :class=\"{ healthProblems: true, hasHealthProblems: !!jobsAlerting.length }\">\r\n\t\t<template v-if=\"jobsAlerting.length > 0\">\r\n\t\t\t<p v-for=\"job in jobsAlerting\" class=\"alertMessage\">{{job.AlertState}}</p>\r\n\t\t</template>\r\n\t\t<template v-else>\r\n\t\t\t<p>All monitors report OK</p>\r\n\t\t</template>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\texport default {\r\n\t\tprops:\r\n\t\t{\r\n\t\t\tjobsAlerting: {\r\n\t\t\t\ttype: Array,\r\n\t\t\t\trequired: true\r\n\t\t\t}\r\n\t\t},\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t};\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t},\r\n\t\twatch:\r\n\t\t{\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.healthProblems\r\n\t{\r\n\t\tborder: 3px solid #000000;\r\n\t\tpadding: 5px 3.3vw;\r\n\t}\r\n\r\n\t\t.healthProblems.hasHealthProblems\r\n\t\t{\r\n\t\t\tborder-color: #CC0000;\r\n\t\t\tcolor: #990000;\r\n\t\t\tfont-weight: bold;\r\n\t\t}\r\n\r\n\t.alertMessage\r\n\t{\r\n\t\twhite-space: pre-line;\r\n\t}\r\n\r\n\t@media (min-width: 600px)\r\n\t{\r\n\t\t.healthProblems\r\n\t\t{\r\n\t\t\tborder: 3px solid #000000;\r\n\t\t\tpadding: 5px 20px;\r\n\t\t}\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
